/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

export interface IErrorContentPluginMethods extends IPluginMethodMap {
  getErrorContentSync(args?: any): any;
}

export class ErrorContentPlugin implements IAgentPlugin {
  readonly methods: IErrorContentPluginMethods;

  constructor() {
    this.methods = {
      getErrorContentSync: this.getErrorContentSync.bind(this),
    };
  }

  getErrorContentSync(args?: any) {
    return {};
  }
}
